<template>
  <div>
    <input
      type="file"
      :id="nome"
      style="display: none"
      @change="handleFileInput"
      :disabled="disabled"
      accept=".pdf"
    />
    <a href="#" @click.prevent="selectFile">
      <div
        :class="
          !disabled ? (uploadSuccess ? 'drop_zone-success' : 'drop_zone') : 'drop-zone-disable'
        "
        @drop="dropHandler"
        @dragover.prevent="dragOverHandler"
        style="display: flex; flex-direction: column; align-items: center; justify-content: center"
      >
        <v-icon
          size="30"
          :color="uploadSuccess ? 'green' : ''"
          :class="disabled ? 'icon' : ' mt-2'"
        >
          {{ uploadSuccess ? 'check_circle' : 'upload_file' }}
        </v-icon>
        <p
          :class="!disabled ? 'truncate-text' : 'truncate-text-disable'"
          style="text-align: center"
        >
          {{ nome }} * <br />
          {{ fileName }} <br />
          <label style="font-size: 11px; color: #828484"
            >Arraste e solte ou clique para selecionar o arquivo</label
          >
        </p>
      </div>
      <p v-if="fileErro" class="erro" style="text-align: center">Por favor selecione {{ nome }}</p>
      <p v-if="fileTypeErro" class="erro" style="text-align: center">
        Arquivo inválido. Envie documento do tipo PDF*
      </p>
      <p v-if="errorSize" class="erro" style="text-align: center">
        Arquivo inválido. Envie documento com tamanho de até 5MB*
      </p>
    </a>
    <!-- <p v-if="uploadSuccess" class="success-message">Upload realizado com sucesso!</p> -->
  </div>
</template>

<script>
import pedidoService from '@/services/sit-pedidos/pedido.service';

export default {
  name: 'UploadFileSubstituicaoCooperado',
  props: {
    nome: String,
    tipoDocumento: String,
    fileName: String,
    disabled: Boolean,
    fileErro: Boolean,
    fileTypeErro: Boolean,
    idPedido: Number,
  },
  data() {
    return {
      errorSize: false,
      uploadSuccess: false,
    };
  },
  methods: {
    dragOverHandler(event) {
      event.preventDefault();
    },
    dropHandler(event) {
      event.preventDefault();
      if (
        !this.disabled &&
        event.dataTransfer.items.length === 1 &&
        event.dataTransfer.items[0].kind === 'file'
      ) {
        const file = event.dataTransfer.items[0].getAsFile();
        if (file.size > 5242880) {
          this.errorSize = true;
        } else if (file.type !== 'application/pdf') {
          this.$emit('file', null);
          this.errorSize = false;
        } else {
          this.$emit('file', file);
          this.errorSize = false;
          // upload automático
          this.uploadFile(file);
        }
      }
      this.removeDragData(event);
    },
    selectFile() {
      if (!this.disabled) document.getElementById(`${this.nome}`).click();
    },
    handleFileInput(event) {
      if (event.target.files[0]) {
        const file = event.target.files[0];
        if (file.size > 5242880) {
          this.errorSize = true;
        } else if (file.type !== 'application/pdf') {
          this.$emit('file', null);
          this.errorSize = false;
        } else {
          this.$emit('file', file);
          this.errorSize = false;
          // upload automático
          this.uploadFile(file);
        }
      }
    },
    uploadFile(file) {
      // if (!this.idPedido || !file) return;
      pedidoService
        .uploadDocumentoSubstituicaoCooperado(this.idPedido, file, this.tipoDocumento)
        .subscribe({
          next: response => {
            // Sucesso no upload
            this.uploadSuccess = true;
            this.$emit('upload-success', response);
          },
          error: err => {
            // Erro no upload
            this.$emit('file', null);
            // this.errorSize = true;
          },
        });
    },
    removeDragData(event) {
      if (event.dataTransfer.items) {
        event.dataTransfer.items.clear();
      }
    },
  },
};
</script>

<style scoped>
.drop_zone {
  border: 1px dashed #444a4c;
  border-radius: 4px;
  width: 99%;
  min-height: 130px;
  padding-top: 8px;
  margin-left: 1.5px;
  background-color: #edebeb;
  margin-top: -5px;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.drop_zone-success {
  border: 1.5px solid #43a047;
  background-color: #e8f5e9;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.drop-zone-disable {
  border: 1px dashed #969999;
  border-radius: 4px;
  width: 99%;
  min-height: 100px;
  padding-top: 8px;
  margin-left: 1.5px;
  text-align: center;
  background-color: #edebeb;
  margin-top: -5px;
  margin-bottom: 12px;
  box-sizing: border-box;
}
.truncate-text {
  color: #444a4c;
  width: 100%;
  box-sizing: border-box;
  overflow-wrap: break-word;
  word-break: break-word;
  padding: 4px;
}
.truncate-text-disable {
  color: #828484;
  width: 100%;
  box-sizing: border-box;
  overflow-wrap: break-word;
  word-break: break-word;
  padding: 4px;
}
.erro {
  color: #f61a1a;
  font-size: 11.5px;
  margin-top: -10px;
  padding-left: 8px;
}
.icon {
  color: #828484;
}
</style>
